/**
 * digitalStamps — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const digitalStampsPack: ToilePack = {
    slug: 'digital-stamps',
    category: 'stamps',
    name: 'Digital stamps',
    tagline: tagline('stamps', 'designs', 'line styles'),
    chips: chips('designs', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'fairy', label: 'Fairy', subject: 'a fairy on a mushroom, wings folded, holding a lantern'},
        {key: 'teddy', label: 'Teddy bear', subject: 'a teddy bear with a stitched muzzle holding a heart'},
        {key: 'bundle', label: 'Flower bundle', subject: 'garden flowers tied with a ribbon bow'},
    ],
    styles: [
        {key: 'clean', label: 'Clean line', style: 'crisp closed outlines of uniform weight', palette: 'black line only', framing: 'centered, white margin, open to color'},
        {key: 'sketchy', label: 'Sketchy pencil', style: 'loose graphite linework, light hatching', palette: 'feathered pencil strokes', framing: 'centered, white margin'},
        {key: 'thick', label: 'Thick outline', style: 'heavy bold contours, thin interior line', palette: 'black line only', framing: 'centered, white margin, easy to cut'},
    ],
    directions: ['a puppy instead', 'in a scalloped frame', 'lighter, fewer details'],
}
